import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import {buttonType, imageType} from '../../../utils/commonPropTypes'
import WavyBackground from '../../../components/WavyBackground'
import WidthContainer from '../../../components/WidthContainer'
import {QueriedGatsbyImage} from '../../../components/GatsbyImage'
import {QueryedButton} from '../../../components/Button'
import StarsContainer from '../../../components/Stars'

const phoneBreakpoint = '@media only screen and (max-width: 1000px)'
const smallerPhoneBreakpoint = '@media only screen and (max-width: 620px)'

const RootContainer = styled(WavyBackground)`
	margin-top: 6.258rem;
	align-items: center;
	justify-content: center;
	overflow: hidden;
`
RootContainer.defaultProps = {
	type: 'darkBlue',
}

const Inner = styled.div`
	display: flex;
	padding-top: 2.3rem;
	padding-bottom: 5.3rem;
	margin: -2.5rem;
	width: 100%;
	position: relative;
	
	
	${phoneBreakpoint} {
		flex-direction: column;
		align-items: center;
		padding-top: 0;
		padding-bottom: 0;
		margin-left: auto;
		margin-right: auto;
	}
`

const Column = styled.div`
	flex: 1;
	margin: 2.5rem;
	max-width: 30rem;
	width: 100%;
	
	${smallerPhoneBreakpoint} {
		text-align: center;
		align-items: center;
	}
`

const Title = styled.h1`
	font-size: ${props => props.theme.fontSizes.big30};
	font-weight: ${props => props.theme.fontWeights.bold};
	margin-bottom: 3rem;
`


const LogosList = styled.div`
	display: flex;
	margin: -1.57rem;
	align-items: center;
	
	${smallerPhoneBreakpoint} {
		flex-direction: column;
	}
`

const Logo = styled.a`
	width: 33.33%;
	flex: 1;
	flex-wrap: wrap;
	display: block;
	margin: 1.57rem;
	transform: scale(1);
	transition: ${props => props.theme.transitions.smallElements} ease;
	
	img {
		margin-bottom: 0;
	}
	
	&:hover {
		transform: scale(1.1);
	}
`

const ButtonStyled = styled(QueryedButton)`
	margin-top: 4rem;
`


const Section = ({title, items, button}) => <Column>
	<Title>{title}</Title>
	<LogosList>
		{items.map(one => <Logo href={one.link}>
			<QueriedGatsbyImage alt='' image={one.icon}/>
		</Logo>)}
	</LogosList>
	<ButtonStyled data={button}/>
</Column>

Section.propTypes = {
	title: PropTypes.string.isRequired,
	items: PropTypes.arrayOf(PropTypes.shape({
		icon: imageType.isRequired,
		link: PropTypes.string.isRequired,
		button: buttonType.isRequired,
	}).isRequired).isRequired,
}

const SponsorsSection = ({className, data}) => <RootContainer className={className}>
	<StarsContainer rotate='-33deg' width='67rem'/>
	<WidthContainer>
		<Inner>
			<Section {...data.sponsors} />
			<Section {...data.partners} />
		</Inner>
	</WidthContainer>
</RootContainer>

SponsorsSection.propTypes = {
	className: PropTypes.string,
	data: PropTypes.shape({
		sponsors: PropTypes.shape({
			title: PropTypes.string.isRequired,
			items: PropTypes.arrayOf(PropTypes.shape({
				icon: imageType.isRequired,
				link: PropTypes.string.isRequired,
				button: buttonType.isRequired,
			}).isRequired).isRequired,
		}).isRequired,
		partners: PropTypes.shape({
			title: PropTypes.string.isRequired,
			items: PropTypes.arrayOf(PropTypes.shape({
				icon: imageType.isRequired,
				link: PropTypes.string.isRequired,
				button: buttonType.isRequired,
			}).isRequired).isRequired,
		}).isRequired,
	}).isRequired,
}

SponsorsSection.defaultProps = {
	className: '',
}

export default SponsorsSection
